import React, { useState } from "react"

import mask from "../../utility/document"

import { FormikErrors, useFormik } from 'formik'

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

function getGaCookie() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith('_ga')) {
            return cookie.split('=')[1];
        }
    }
    return null;
}

function extractGaValue(cookieValue: string | null) {
    if (!cookieValue) {
        return 'ga:unknown';
    }
    const parts = cookieValue.split('.');
    if (parts.length >= 4) {
        return parts[2] + '.' + parts[3];
    }
}

function Form({ themeMode }: any) {
    const [showMessage, setShowMessage] = useState(false)
    const [statusMessage, setStatusMessage] = useState("")
    const [success, setSuccess] = useState(false)
    const [country] = useState({ countryCode: '55' })

    interface FormDataType { name: string, phone: string, emailConfirm: string, email: string, document: string, acceptTerms: string }
    const responseBody = { name: "", telefone: "", account: { email: "", emailConfirm: "" }, document: "", cpf: "", cnpj: "", acceptTerms: "string" }
    const onSubmitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        responseBody.name = formik.values.name
        responseBody.telefone = formik.values.phone
        responseBody.account.email = formik.values.email
        responseBody.account.emailConfirm = formik.values.emailConfirm
        responseBody.document = formik.values.document
        responseBody.acceptTerms = formik.values.acceptTerms

        if (responseBody.document.replace(/[^0-9]/g, "").length > 11) {
            responseBody.cnpj = responseBody.document
        } else {
            responseBody.cpf = responseBody.document
        }

        if (!validateErrors(formik.errors)) {
            setShowMessage(true)
            setStatusMessage("Preencha todos os campos corretamente.")
            setSuccess(false)
        } else {
            try {

                const r = await fetch(`${process.env.REACT_APP_PARCEIRANDO_LANDING_AFFILIATE_SAVE}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Basic ${process.env.REACT_APP_API_TOKEN}`
                    },
                    body: JSON.stringify(responseBody)
                })
                const result = await r.json()
                setShowMessage(true)
                if (result && result.status === 200) {
                    setStatusMessage("Cadastro realizado com sucesso, verifique seu e-mail para mais informações. (cheque a caixa de spam)")
                    setSuccess(true)
                    const gaCookieValue = getGaCookie();
                    const gaValue = extractGaValue(gaCookieValue);
                    // send analytics
                    const googleParams = {
                        client_id: gaValue,
                        events: [{
                            name: "conversion_event_submit_lead_form",
                            params: {
                                utm_source: document.referrer || 'direct',
                                utm_medium: 'Parceirando',
                                utm_campaign: 'parceirando_afiliados',
                                utm_content: 'parceirando',
                                page_title: 'Afiliados - Parceirando',
                                lead_from: 'Afiliados - Parceirando',
                                page_url: window.location.href,
                                page_referrer: document.referrer || 'direct',
                                page_location: window.location.href,
                                page_host: window.location.hostname,
                                affiliate_name: formik.values.name,
                                affiliate_email: formik.values.email,
                                affiliate_phone: formik.values.phone
                            }
                        }],
                    }
                    try {
                        fetch('https://links.parceirando.com.br/api/google-analytics', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(googleParams),
                        }).then((response) => { })
                            .catch((error) => { });
                    } catch (error) {
                        console.error('Error:', error);
                    }
                } else {
                    if (result?.message === 'global.account.exist') {
                        setStatusMessage("Ops, já existe uma conta com o e-mail informado.")
                    } else {
                        setStatusMessage("Erro ao realizar o cadastro. Tente novamente mais tarde.")
                    }
                    setSuccess(false)
                }
            } catch (error) {
                setStatusMessage("Erro ao realizar o cadastro. Tente novamente mais tarde.")
                setSuccess(false)
            }


        }


    }

    const validatePhone = (value: string, country: any) => {

        const brRegex = /^55(\d{2})?(\d{10}|\d{11})$/
        if (!value || value.length < 3) {
            return true
        }
        const v = value.replace(/[^\d]/g, '');
        // setCountry(country)
        // setCountry({ countryCode: country.countryCode });
        if (country.countryCode === '55' && !v.match(brRegex)) {
            return false
        } else if (country.countryCode === '1') {
        } else if (country.countryCode === '52') {
        }
        return true
    }

    const validate = (values: FormDataType) => {
        let errors = {
            email: '',
            emailConfirm: '',
            document: '',
            name: '',
            phone: '',
            acceptTerms: ''
        }

        if (!values.email) {
            errors.email = 'Obrigatório'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'E-mail Inválido'
        }

        if (!values.emailConfirm) {
            errors.emailConfirm = 'Obrigatório'
        } else if (values.emailConfirm !== values.email) {
            errors.emailConfirm = 'E-mail não confere!'
        }

        if (!values.document) {
            errors.document = 'Obrigatório'
        } else {
            let doc = mask(values.document)
            if (!doc || doc.length === 0) {
                errors.document = 'Documento Inválido'
            } else {
                values.document = doc
            }
        }
        if (!values.name) {
            errors.name = 'Obrigatório'
        } else {
            const NAME_REGEX = /^[a-zA-Z]+ [a-zA-Z]+$/
            const isValidName = NAME_REGEX.test(values.name)
            if (!isValidName) {
                errors.name = 'Nome/Razão inválido'
            }

        }
        if (!values.phone) {
            errors.phone = 'Obrigatório'
        } else {
            if (!validatePhone(values.phone, country)) {
                errors.phone = 'Telefone Inválido'
                if (values.phone.length <= 7) {
                    formik.values.phone = country.countryCode
                }
            }
        }

        if (!values.acceptTerms) {
            errors.acceptTerms = 'Obrigatório'
        }

        return errors
    }

    const formik = useFormik({
        initialValues: {
            email: '',
            name: "",
            phone: "",
            emailConfirm: "",
            document: "",
            acceptTerms: "false"
        },
        validate,
        onSubmit: (values) => { },

    })

    return (
        <div className="col-lg-12 col-md-12">
            {/* <!-- Start Contact Section --> */}
            <form className={` ${themeMode === "light" ? "form-light" : ""}`} onSubmit={onSubmitHandler} >
                <div className="form-group">
                    <input type="text" className="form-control" id="name" required placeholder="Nome Completo/Razão Social" onChange={formik.handleChange} onBlur={formik.handleBlur} onKeyUp={formik.handleChange} onInput={formik.handleChange} value={formik.values.name} />
                    {formik.errors.name ? (
                        <span className="text-warning" style={{ marginLeft: "18px" }}>{formik.errors.name}</span>
                    ) : null}
                </div>
                <div className="form-group">
                    <input type="email" className="form-control" id="email" required placeholder="E-mail" onChange={formik.handleChange} onBlur={formik.handleBlur} onKeyUp={formik.handleChange} value={formik.values.email} />
                    {formik.errors.email ? (
                        <span className="text-warning" style={{ marginLeft: "18px" }}>{formik.errors.email}</span>
                    ) : null}
                </div>
                <div className="form-group">
                    <input type="email" className="form-control" id="emailConfirm" required placeholder="Confirme E-mail" onChange={formik.handleChange} onBlur={formik.handleBlur} onKeyUp={formik.handleChange} value={formik.values.emailConfirm}
                    />
                    {formik.errors.emailConfirm ? (
                        <span className="text-warning" style={{ marginLeft: "18px" }}>{formik.errors.emailConfirm}</span>
                    ) : null}
                </div>

                <div className="form-group">
                    <input type="text" className="form-control" id="document" maxLength={18} required placeholder="CPF/CNPJ" onChange={formik.handleChange} onBlur={formik.handleBlur} onKeyUp={formik.handleChange} value={formik.values.document} />
                    {formik.errors.document ? (
                        <span className="text-warning" style={{ marginLeft: "18px" }}>{formik.errors.document}</span>
                    ) : null}
                </div>

                <div className="form-group">
                    <PhoneInput isValid={(value: string, country: object) => {
                        return validatePhone(value, country)
                    }} inputProps={{ required: true, id: "phone", name: "phone", onChange: formik.handleChange, onBlur: formik.handleBlur }} buttonStyle={{ height: 'inherit' }} inputStyle={{ paddingLeft: 50, width: '100%', height: 'inherit' }} enableSearch={true} searchPlaceholder="Selecione seu país" inputClass="form-control"
                        country={'br'} onlyCountries={['br', 'us', 'mx']} placeholder="Telefone" value={formik.values.phone}
                    />
                    {formik.errors.phone ? (
                        <span className="text-warning" style={{ marginLeft: "18px" }}>{formik.errors.phone}</span>
                    ) : null}
                </div>

                <div className="form-group">
                    <input type="checkbox" className="form-check-input" id="acceptTerms" style={{ backgroundColor: "black" }} required onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.acceptTerms} />
                    <label htmlFor="acceptTerms" className="form-check-label " style={{ marginLeft: "10px", cursor: "pointer", position: "relative", top: "10px" }}>Aceito os <a href="https://parceirando.s3.amazonaws.com/termo-de-uso-parceirando-afiliado.pdf" rel="noreferrer" target="_blank">Termos e Condições</a></label>
                    {formik.touched.acceptTerms && formik.errors.acceptTerms ? (
                        <span className="text-warning" style={{ marginLeft: "10px", cursor: "pointer", position: "relative", top: "10px" }}>{formik.errors.acceptTerms}</span>
                    ) : null}
                </div>
                {/* <div className="form-group">
                    <textarea className="form-control" id="exampleFormControlTextarea1" rows={4}
                        placeholder="Message"></textarea>
                </div> */}

                {showMessage && <div className={`form-group ${success ? "text-success" : "text-warning"}`}>{statusMessage}</div>}
                <button type="submit" className="br-learn-more-right"><span className="text">Enviar</span></button>
            </form>
            {/* <!-- End Contact Section --> */}
        </div>
    )

}
export default Form

function validateErrors(errors: FormikErrors<{ email: string; name: string; phone: string; emailConfirm: string; document: string; acceptTerms: string }>) {
    const hasErrors = Object.values(errors).some((value) => value !== undefined && value !== "");
    return !hasErrors;
}
